export default __webpack_public_path__ + "static/media/fk.be3d0481.jpg";